import React from "react";
import { useRouter } from "next/router";
import {
  ListItem,
  ListItemButton as MuiListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Link from "next/link";

const NavListItemButton = ({ path, icon, label, clickHandler = null }) => {
  const router = useRouter();
  const isActive = router.pathname === path;

  return (
    <ListItem disablePadding>
      <Link href={path ? path : '#'} 
      passHref 
      // legacyBehavior
      onClick={(e) => { 
        (typeof clickHandler == "function") ? clickHandler() : console.log("not a function") 
      }
      }>
        <MuiListItemButton
          // href={path}
          sx={{
            background: isActive ? "#004fe01f" : "#ffffff",
            "& .MuiListItemIcon-root": {
              color: isActive ? "#004FE0" : "#001233",
            },
            "& .MuiListItemText-root": {
              color: isActive ? "#004FE0" : "#001233",
              fontWeight: 500,
            },
            borderRadius: "8px",
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={label} />
        </MuiListItemButton>
      </Link>
    </ListItem>
  );
};

export default NavListItemButton;
